import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { ScoreStatus } from '@sorare/core/src/__generated__/globalTypes';
import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BodyM, BrandM, LabelS } from '@sorare/core/src/atoms/typography';
import { Score } from '@sorare/core/src/components/scoring/Score';
import { useSportContext } from '@sorare/core/src/contexts/sport';

import { TutorialBezel } from '#src/components/quickPlay/QuickPlayTutorialDialog/TutorialBezel/index.tsx';
import {
  getCutPlayerCard,
  useScoreAverageCountBySport,
} from '#src/components/quickPlay/QuickPlayTutorialDialog/utils.tsx';

const Img = styled.img`
  position: relative;
  bottom: calc(-1 * var(--double-unit));
  width: calc(12 * var(--unit));
  height: calc(100% + var(--double-unit));
  object-fit: cover;
`;

export const Average = () => {
  const { sport } = useSportContext();
  const scoreAverageCountBySport = useScoreAverageCountBySport();
  return (
    <TutorialBezel color="var(--c-green-400)">
      <Vertical gap={2.5}>
        <Vertical center className="text-center">
          <BrandM>
            <FormattedMessage
              id="L10Average.title2"
              defaultMessage="Every player has a L{scoreAverageCount}*"
              values={{
                scoreAverageCount: scoreAverageCountBySport[sport],
              }}
            />
          </BrandM>
          <BodyM color="var(--c-nd-600)">
            <FormattedMessage
              id="L10Average.description2"
              defaultMessage="<em>*L{scoreAverageCount}</em> = Last {scoreAverageCount} Games Average"
              values={{
                em: chunks => (
                  <BodyM bold color="var(--c-white)" as="span">
                    {chunks}
                  </BodyM>
                ),
                scoreAverageCount: scoreAverageCountBySport[sport],
              }}
            />
          </BodyM>
        </Vertical>
        <Horizontal center>
          <Img src={getCutPlayerCard(sport)} alt="" />
          <Vertical center>
            <LabelS bold color="var(--c-nd-600)">
              L{scoreAverageCountBySport[sport]}
            </LabelS>
            <Score
              hideReviewing
              shape="HEXAGON"
              score={50}
              scoreStatus={ScoreStatus.FINAL}
              scoreType="PLAYER_SCORE"
            />
          </Vertical>
        </Horizontal>
      </Vertical>
    </TutorialBezel>
  );
};
